<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>投流管理</span>
        <div class="filters">
          <el-select v-model="payStatus" placeholder="支付状态" clearable style="width: 120px" @change="handleSearch">
            <el-option v-for="opt in payOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
          <el-select v-model="execStatus" placeholder="执行状态" clearable style="width: 120px" @change="handleSearch">
            <el-option v-for="opt in execOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </div>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="userId" label="用户ID" width="90" />
        <el-table-column prop="productId" label="商品ID" width="90" />
        <el-table-column prop="targetUrl" label="推广链接" min-width="180" show-overflow-tooltip />
        <el-table-column prop="amount" label="金额" width="90" />
        <el-table-column prop="payStatus" label="支付" width="90">
          <template slot-scope="{ row }">{{ labelOf(PAY_STATUS, row.payStatus) }}</template>
        </el-table-column>
        <el-table-column prop="execStatus" label="执行" width="90">
          <template slot-scope="{ row }">{{ labelOf(EXEC_STATUS, row.execStatus) }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="下单时间" min-width="160" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.execStatus === 0"
              type="text"
              size="small"
              @click="handleComplete(row)"
            >标记完成</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getPromotionOrders, updatePromotionExec } from '@/api/admin'
import { PAY_STATUS, EXEC_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import listPage from '@/mixins/listPage'

export default {
  name: 'TrafficPromotion',
  mixins: [listPage],
  data() {
    return {
      PAY_STATUS,
      EXEC_STATUS,
      payStatus: null,
      execStatus: null
    }
  },
  computed: {
    payOptions() {
      return optionsOf(PAY_STATUS)
    },
    execOptions() {
      return optionsOf(EXEC_STATUS)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    fetchList(params) {
      return getPromotionOrders({
        ...params,
        payStatus: this.payStatus != null ? this.payStatus : undefined,
        execStatus: this.execStatus != null ? this.execStatus : undefined
      })
    },
    handleComplete(row) {
      this.$confirm('确认标记执行完成？', '提示', { type: 'warning' }).then(async () => {
        try {
          await updatePromotionExec(row.id, 1)
          this.$message.success('已更新')
          this.loadList()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filters {
  display: flex;
  gap: 8px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
